"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeGuideTabs = void 0;
exports.PracticeGuideTabs = {
    ALERTS: 'Alerts',
    CONTACT_INFO: 'Contact Info',
    LOCATIONS: 'Locations'
};
//# sourceMappingURL=types.js.map